import fonts, { fontSizes } from '../shared/fonts'
import getResponsiveProps from '../shared/responsive'
import transition from '../shared/transition'
import spacing from '../shared/spacing'
import * as utilities from '../utilities'

const myRefinitivTheme = {
  palette: {
    primary: '#001eff',
    primaryDark: '#0013a1',

    accent1: '#ff5000',
    accent1Dark: '#dc4500',
    accent2: '#d0d3d4',

    complementary1: '#00d0d4',
    complementary1Dark: '#0a8285',
    complementary2: '#dc0a0a',
    complementary2Dark: '#a00000',
    complementary3: '#498502',
    complementary3Dark: '#387c2b',
    complementary4: '#6e3ab7',
    complementary4Dark: '#621f95',
    complementary5: '#ffc800',

    greyLightest: '#f4f4f4',
    greyLighter: '#eaeaea',
    greyMuted: '#dddddd',
    greyLight: '#afafaf',
    grey: '#666666',
    greyDark: '#4d4d4d',
    greyDarker: '#3d3d3d',
    greyDarkest: '#262626',

    modalBg: 'rgba(61, 61, 61, 0.9)',

    fileType: {
      doc: '#2a5699',
      xls: '#20744b',
      ppt: '#a00000',
      pdf: '#da1f1f',
      zip: '#efc314',
      txt: '#6d3ab7',
      img: '#0199c4'
    }
  },
  typography: {
    baseFontSize: 16,
    fontFamily: {
      sansSerif: 'arial, helvetica, clean, sans-serif',
      serif: 'georgia, "times new roman", times, serif',
      monospace: 'menlo, monaco, consolas, "courier new", monospace',
      ...fonts
    },
    fontSize: {
      ...fontSizes
    }
  }
}

export default ({ breakpoints }) => ({
  ...myRefinitivTheme,
  transition,
  spacing,
  utilities,
  responsive: getResponsiveProps(breakpoints)
})
